import React, { useState, useEffect, useRef, useMemo, useCallback} from 'react';
import { useLocation } from 'react-router-dom';
import { AgGridReact } from "ag-grid-react";
import { AllEnterpriseModule } from 'ag-grid-enterprise';
import { ModuleRegistry, AllCommunityModule, themeBalham } from 'ag-grid-community';
import { useDispatch, useSelector } from "react-redux";
import { Drawer } from '@material-ui/core';
import { Snackbar } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { isEmpty, CellType, removeDuplicates, tagformat, setglobaldata, DeepCopy, getglobaldata, DicVal, arrayDiff, Savestorage, Getstorage, customTarget } from '../modules/appLibrary';
import Divider from '@material-ui/core/Divider';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import CustomToolPanel from "../components/CustomToolPanel";
import CustomToolorgPanel from "../components/CustomToolorgPanel";
import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import InputBase from '@material-ui/core/InputBase';
import { makeStyles } from '@material-ui/core/styles';
import { tagsearchopen, tagsearchclose } from '../modules/tagsearchliststore';
import { setsearchtoolpanel, searchaddlayout, setsearchtag } from '../modules/searchliststore';
import TagRenderer from "./RenderTag.js";
import SearchPanel from "../components/SearchPanel";
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Box from '@mui/material/Box';

// 必要なモジュールを登録
ModuleRegistry.registerModules([
    AllEnterpriseModule,
    AllCommunityModule
]);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        padding: '0 10px',
        height: 30,
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    divider: {
        height: 28,
        margin: 4,
    },
   chip: {
        margin: theme.spacing(0.2),
    },
    label: {
        fontSize: "12px"
    },
    snackbar: {
        maxWidth:250,
        backgroundColor: '#F7F8F9',
        color: '#000',
    }
}));


//---------------------------------------------------------------------
//  マスタ検索リスト
//
//  inTag: true:検索リスト内TAG検索
//  SearchPanel:検索パネル内からの呼び出し
//  zindex:呼び元のzindex
//---------------------------------------------------------------------
//  検索条件有無はコントローラに対するtype<100の検索項目が存在するかによって決まる
//　リスト項目検索と同じ
//---------------------------------------------------------------------
export default function SearchList(props) {
    const AGRef = useRef();
    const fnc = useRef();
    const dispatch = useDispatch();
    const ComFunc = React.forwardRef(ComFunction);
    const AGFunc = React.forwardRef(AGFunction);
    const location = useLocation();

    const admin = useSelector(state => state.user.authority);
    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const open = useSelector(state => props.SearchPanel ? props.open : state.search.open);
    const multiple = useSelector(state => props.SearchPanel ? props.multiple : state.search.multiple);
    const rowmode = useSelector(state => props.SearchPanel ? props.rowmode : state.search.rowmode);      //false:maltiple=trueの場合複数項目をspace区切りで取得
    const label = useSelector(state => props.SearchPanel ? props.label : state.search.label);
    const datainfo = useSelector(state => props.SearchPanel ? props.data : state.search.data);
    const rowid = useSelector(state => props.SearchPanel ? props.rowid : state.search.rowid);
    const currowid = useSelector(state => state.search.currowid);
    const taglist = useSelector(state => props.SearchPanel ? props.taglist : state.search.taglist);
    const doApply = useSelector(state => props.SearchPanel ? props.doApply : state.search.doApply);
    const exdataid = useSelector(state => props.SearchPanel ? "" : state.search.exdataid);
    const rowdata = useSelector(state => props.SearchPanel ? null : state.search.rowdata);

    const api = useSelector(state => state.search.gridApi);

    const tagopen = useSelector(state => state.tagsearch.open);
    const tagdatainfo = useSelector(state => state.tagsearch.data);
    const doTagApply = useSelector(state => state.tagsearch.doApply);
    const tagzindex = useSelector(state => state.tagsearch.zindex);
    const storagename = useSelector(state => state.form.storagename);

    const [show, setshow] = useState(false)
    const [rowSelection, setrowSelection] = useState('single')
    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [rowData, setRowData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [rowHeight, setRowHeight] = useState(null);
    const [searchitems, setsearchitems] = useState([]);     //検索リスト項目
    const [showselect, setshowselect] = useState(false);  //snackbar
    const [selectlists, setselectlists ] = useState([]);
    const [taginfo, settaginfo] = useState([]);
    const [zindex, setzindex] = useState(1300);

    const [isexc, setisexc] = React.useState(false);        //true:TAG,保管データなど
    const [cmdtype, setcmdtype] = React.useState(0);         //0:適用 1:TAG 2:保管データ
    const [useSearchPanel, setuseSearchPanel] = React.useState(false);
    const [searchword, setsearchword] = useState("");
    const [searchtaglist, setsearchtaglist] = useState([]);
    const [tagkey, settagkey] = useState("");
    const [tagdel, settagdel] = useState(false);
    const [searchpanelopen, setsearchpanelopen] = useState(false);
    const [drawerWidth, setDrawerWidth] = useState(700);
    const drawerResizeRef = useRef(null);
    const initialSelectionAppliedRef = useRef(false);

    const CELLTYPE = CellType();
    const classes = useStyles();
    const [toolpanels, settoolpanels] = useState([]);
    const colfixkey = "search_colfix"; //列幅最適化
    const vertical = "bottom";
    const horizontal = "right";

    const [shared, setShared] = React.useState(false);

    const stopDrawerResize = useCallback(() => {
        if (drawerResizeRef.current === null) return;
        window.removeEventListener('mousemove', drawerResizeRef.current.handleMouseMove);
        window.removeEventListener('mouseup', drawerResizeRef.current.handleMouseUp);
        document.body.style.userSelect = drawerResizeRef.current.userSelect;
        drawerResizeRef.current = null;
    }, []);

    function handleResizeMouseDown(event) {
        event.preventDefault();
        stopDrawerResize();

        function handleMouseMove(moveEvent) {
            moveEvent.preventDefault();
            const minWidth = 600;
            const maxWidth = Math.max(minWidth, window.innerWidth - 100);
            const nextWidth = window.innerWidth - moveEvent.clientX;
            setDrawerWidth(Math.min(maxWidth, Math.max(minWidth, nextWidth)));
        }

        function handleMouseUp() {
            stopDrawerResize();
        }

        drawerResizeRef.current = {
            handleMouseMove,
            handleMouseUp,
            userSelect: document.body.style.userSelect
        };
        document.body.style.userSelect = 'none';
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
    }

    useEffect(() => {
        function handleWindowResize() {
            const maxWidth = Math.max(600, window.innerWidth - 100);
            setDrawerWidth(currentWidth => currentWidth > maxWidth ? maxWidth : currentWidth);
        }

        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
            stopDrawerResize();
        };
    }, [stopDrawerResize]);

    const sharedChange = (event) => {
        setShared(event.target.checked);
        GetMasterList(false,null, event.target.checked);
    };

    const icons = useMemo(() => {
        return {
            'custom-tools': '<i class="material-icons min">star</i>',
            'custom-tools2': '<i class="material-icons min">table_chart</i>',
        };
    }, []);
   const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: true,
        wrapText: true,
        menuTabs: ['filterMenuTab', 'generalMenuTab'],
        tooltipValueGetter: (params) => { return params.column.colId.indexOf( 'name') !== -1 || params.column.colId === 'tag' ? params.value : null; }
    };

    function applyInitialSelection(api) {
        if (!open || !multiple || rowSelection !== 'multiple' || initialSelectionAppliedRef.current || !api) return;
        if (isEmpty(datainfo) || !Array.isArray(datainfo.initialSelectedCodes)) return;

        const nodes = [];
        api.forEachNode(node => nodes.push(node));
        if (nodes.length === 0) return;

        const initialCodeSet = new Set(datainfo.initialSelectedCodes
            .map(code => code === null || code === undefined ? '' : String(code).trim())
            .filter(code => code !== ''));

        initialSelectionAppliedRef.current = true;
        api.deselectAll();
        nodes.forEach(node => {
            const code = node.data && node.data.code !== null && node.data.code !== undefined
                ? String(node.data.code).trim()
                : '';
            if (code !== '' && initialCodeSet.has(code)) {
                node.setSelected(true);
            }
        });
    }


    useEffect(() => {
        if (props.inTag) return;
        //通常
        setshow(open);
        if (open) {
            initialSelectionAppliedRef.current = false;
            if (!isEmpty(props.zindex)) setzindex(props.zindex + 100);
            let id = dataid();
            if (id !== '') {
                let data = Getstorage(corpkey, account, "SearchList_" + searchinfokey());
                GetMasterList(true,null,DicVal(data,'shared',false));
                setrowSelection(multiple ? 'multiple' : 'single')
                settagkey(id + "_tag");      //Search Tagキー
                setisexc(datainfo.datatype === CELLTYPE.TAG || 
                    id === "p_storage" || id === "m_group" || id === "p_storage_wp" || id === "history" || id === "sm_ptn")
                if (datainfo.datatype === CELLTYPE.TAG) setcmdtype(1);
                if (id === "p_storage" || id === "sm_ptn") setcmdtype(2);

           }
            else {
                setrowSelection('single');
                setisexc(true);
                if (datainfo.datatype === CELLTYPE.SELECT) {
                    let coldef = AGRef.current.GetColState(datainfo.columnid, [
                        { headerName: "コード", colId: 'code', field: 'code', filter: 'agTextColumnFilter' },
                        { headerName: "名称", colId: 'name', field: 'name', filter: 'agTextColumnFilter' }
                    ]);
                    setColumns(coldef);
                    setRowHeight(AGRef.current.GetRowHeight(storagekey(), null));
                    setRowData(datainfo.options);
                } else {
                    setColumns([
                        { headerName: "コード", colId: 'code', field: 'code' , hide:true},
                        { headerName: "値", colId: 'name', field: 'name', filter: 'agTextColumnFilter',flex:1 }
                    ]);
                }
            }
            toolpanel();
        } else {
            initialSelectionAppliedRef.current = false;
            setsearchword("");
            setsearchtaglist([]);
            setshowselect(false);
            setselectlists([]);
            setcmdtype(0);
            setColumns([]);
            setRowData([]);
            settagdel(false);
        }
    }, [open])

    useEffect(() => {
        if (!open) return;
        applyInitialSelection(gridApi);
    }, [open, gridApi, rowSelection, datainfo, multiple])

    useEffect(() => {
        if (!props.inTag) return;
        //検索リスト内TAG検索
        setshow(tagopen);
        if (tagopen) {
            setsearchword("");
            setsearchtaglist([]);
            setshowselect(false);
            setselectlists([]);
            setisexc(true);
            setrowSelection('multiple');
            GetMasterList(true);
            settagkey(tagdatainfo.dataid + "_tag");      //Search Tagキー
            setzindex(tagzindex + 100);
        } else {
            setColumns([]);
            setRowData([]);
        }
    }, [tagopen])


      useEffect(() => {
        if (gridApi === null) return;
        setglobaldata(tagkey, searchtaglist);
        gridApi.onFilterChanged();
    }, [searchtaglist]);

    useEffect(() => {
        if (gridApi === null) return;
        //検索ワード及びタグを復元（アカウント単位）
        if (!isEmpty(dataid())) {
            let data = Getstorage(corpkey, account, "SearchList_" + searchinfokey());
            if (!isEmpty(data)) {
                if (!isEmpty(data.word)) FilterSearch(data.word);
                setsearchtaglist(data.taglist);
                setShared(DicVal(data, 'shared', false));
            }
        }
    }, [gridApi]);

    useEffect(() => {
        if (!open) return;
        if (isEmpty(rowid)) return;
        if (rowid.length > 1 && !isEmpty(api)) {
            //選択行保持
            for (let i = 0; i < rowid.length; i++) {
                let rowNode = api.getRowNode(rowid[i]);
                rowNode.setSelected(true);
            }
        }
    }, [rowid])

    function dataid() {
        if (isEmpty(datainfo)) return '';
        if (datainfo.dataid !== '') return datainfo.dataid;
        if (datainfo.primary) {
            if (isEmpty(exdataid)) return '';
            else return exdataid;
        }
        if (datainfo.history) return "history";
        return '';
    }
    function searchinfokey() {
        if (dataid() === "sm_ptn") {
            return "ptn_" + datainfo.type;
        } else {
            return dataid();
        }
    }
 
    //マスタリスト取得
    async function GetMasterList(initial, itemdata, setshared) {
        try {
            var keyinfo = null;
            var id = dataid();
            const currentDataid = props.inTag ? DicVal(tagdatainfo, "dataid", "") : id;
            if (dataid() === "sm_ptn") {
                if (!isEmpty(setshared)) keyinfo = setshared ? "shared" : null;
                else {
                    if (shared) keyinfo = "shared";
                }
            } else {
                keyinfo = isEmpty(datainfo) ? null : datainfo.keyinfo;
            }
            fnc.current.postaxios('common/GetSearchMasterList',
                {
                    "dataid": props.inTag ? tagdatainfo.dataid : id,
                    "items": searchitems,
                    "values": itemdata,
                    "rowdata": isEmpty(rowdata)?props.rowdata:rowdata,
                    "keyinfo": keyinfo,
                    "datainfo":datainfo,
                    "initial":initial
                },
                {
                    onSuccess: function (data) {
                        const sourceRowData = Array.isArray(data.rowdata) ? data.rowdata : [];
                        const normalizedRowData = isEmpty(currentDataid) ? sourceRowData :
                            sourceRowData.map(item => ({ ...item, dataid: currentDataid }));
                        setRowHeight(AGRef.current.GetRowHeight(storagekey(), data.RowHeight));
                        let coldef = data.coldef;
                        if (coldef.length===0) {
                            coldef = createColDef(data.colinfo, data.columns, data.prelayout, data.initlayout.trim().length === 0);
                        }
                        setglobaldata(colfixkey, data.fitColumn);    //リアルタイム反映
                        dispatch(setsearchtoolpanel({
                            layouts: data.layouts, prelayout: data.prelayout,
                            initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                            showlimit:data.showlimit,
                            fitColumn: data.fitColumn,
                            useSearchPanel:data.items !== null
                        }));
                        if (data.items !== null) setsearchitems(data.items);
                        setuseSearchPanel(data.items !== null);
                        if (data.colinfo !== null) {
                            settaginfo(AGRef.current.GetTagColumnInfo(data.colinfo));
                        }
                        setColumns(coldef);
                        if (!props.inTag) {
                            if (datainfo.datatype === CELLTYPE.TAG) {
                                let addtag = [];
                                if (!isEmpty(taglist)) {
                                    taglist.forEach(function (list) {
                                        if (!normalizedRowData.some(e => e.code === list.code)) {
                                            addtag.push(list);
                                        }
                                    });
                                }
                                setRowData([...addtag, ...normalizedRowData]);
                                fnc.current.wait(false);
                                return;
                            }
                        } 
                        setRowData(normalizedRowData);
                        if (!isEmpty(data.note)) {
                            fnc.current.successmsg(data.note);
                        }
                        if (!props.inTag && normalizedRowData.length !== 0)
                            if (isEmpty(datainfo.searchparam)) {
                                //条件指定がない場合データ差し替え
                                fnc.current.asignMaster(currentDataid, normalizedRowData);
                            } else {
                                //条件指定がある場合マージ
                                fnc.current.margeMaster(normalizedRowData);
                            }

                        fnc.current.wait(false);
                    }
            })
        } catch (error) {
            console.log(error);
        }
    }
    const RowNodeId = (data) => {
        return isexc ? data.code : data.rowid;
    };
    function createColDef(all, columns, prelayout, initlayout) {
        var colDef = [];
        if (prelayout || initlayout) {  //前回レイアウト or 既定レイアウト
            try {
                for (let i = 0; i < all.length; i++) {
                    let hide = false;
                    let result = columns.filter(e => e.columnid === all[i].columnid);
                    hide = result.length === 0;
                    let column = {
                        headerName: all[i].columnnm,
                        field: all[i].columnid,
                        colId: all[i].columnid,
                        hide: hide,
                        editable: false,
                        datatype: all[i].datatype,
                        colinfo: all[i]
                    }
                    if (!hide) {
                        column['width'] = result.width;
                        //    column['pinned'] = result.pin;
                    }

                    AGRef.current.SetColDefTypeInfo(all[i].datatype, column);

                    colDef.push(column);
                }
            } catch (error) {
                console.log(error);
            }
            //前回レイアウト適用
            if (prelayout) {
                colDef = AGRef.current.GetColState(storagekey(), colDef);
            } else {
                //列幅のみ適用
                let newcolDef = AGRef.current.LoadColState(storagekey());
                if (!isEmpty(newcolDef)) {
                    for (let i = 0; i < colDef.length; i++) {
                        let item = newcolDef.find(e => e.colId === colDef[i].colId);
                        if (!isEmpty(item)) colDef[i].width = item.width;
                    }
                }
            }
        } else {
            for (let i = 0; i < columns.length; i++) {
                let result = all.filter(e => e.columnid === columns[i].columnid);
                if (isEmpty(result)) continue;
                let column = {
                    headerName: columns[i].columnnm,
                    field: columns[i].columnid,
                    colId: columns[i].columnid,
                    hide: false,
                    editable: false,
                    datatype: columns[i].datatype,
                    colinfo: columns[i],
                    width: columns[i].width,
                }
                AGRef.current.SetColDefTypeInfo(columns[i].format.indexOf('numstyle') !== -1 ? CELLTYPE.NUM : columns[i].datatype, column);
                colDef.push(column);
            }
            //保存レイアウト項目以外を追加
            for (let i = 0; i < all.length; i++) {
                let hide = true;
                let result = columns.find(e => e.columnid === all[i].columnid);
                if (!isEmpty(result)) continue;
                let column = {
                    headerName: all[i].columnnm,
                    field: all[i].columnid,
                    colId: all[i].columnid,
                    hide: hide,
                    editable: false,
                    datatype: all[i].datatype,
                    colinfo: all[i]
                }
                AGRef.current.SetColDefTypeInfo(all[i].format.indexOf('numstyle') !== -1 ? CELLTYPE.NUM : all[i].datatype, column);
                colDef.push(column);
            }
        }
        return colDef;
    }
    //レイアウト呼び出し
    function calllayout(layoutid) {
        fnc.current.postaxios('common/GetListColumns',
            { "controller": dataid(), "subkey": "", "type": "1000", "code": layoutid },
            {
                onSuccess: function (data) {
                    var coldef = createColDef(data.colinfo, data.columns, false, data.initlayout.trim().length === 0);
                    setColumns(coldef);
                    AGRef.current.SaveColState(storagekey());
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト登録
    function savelayout(mode, layoutid) {
        fnc.current.postaxios('common/SaveLayout',
            {
                "controller": dataid(), "subkey": "", "type": "1000",
                "code": layoutid, "mode": mode,
                "coldef": AGRef.current.GetshownColDef()
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(searchaddlayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //StorageDelete
    function StorageDelete(codes) {
        let url = location.pathname.replace('/', '') + "/StorageDelete";
        let code = codes[0];
        fnc.current.postaxios(url,
            {
                "controller": datainfo.keyinfo,
                "code": code
            },
            {
                onSuccess: function (data) {
                    let newrow = rowData.filter(e=>e.code!==codes[0]);
                    setRowData(newrow);
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //patternDelete
    function PatternDelete(codes) {
        let code = codes[0];
        fnc.current.postaxios('common/PatternDelete',
            {
                "type": datainfo.type,
                "code": code,
                "initial":shared 
            },
            {
                onSuccess: function (data) {
                    let newrow = rowData.filter(e => e.code !== codes[0]);
                    setRowData(newrow);
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }

    function shouldUseCodeAsApplyValue() {
        if (!customTarget(corpkey, 'tsi')) return false;
        if (isEmpty(datainfo)) return false;
        return datainfo.datatype === CELLTYPE.MASTER
            || datainfo.datatype === CELLTYPE.MASTERREF
            || datainfo.datatype === CELLTYPE.MASTERCODE
            || datainfo.datatype === CELLTYPE.MASTERASST;
    }

    //mode:0=適用or挿入 1:上書 
    function Execute(mode, selectnode) {
        var items = [];
        var codes = [];
        const useCodeAsApplyValue = shouldUseCodeAsApplyValue();
        if (mode !== 2) {   
            var lst = gridApi.getSelectedNodes();
            if (lst.length === 1) {
                if (isexc || useCodeAsApplyValue) {
                    codes.push(lst[0].data.code);
                } else {
                    codes.push(lst[0].data.rowid);
                }
                items.push(lst[0]);
            } else {
                for (let i = 0; i < selectlists.length; i++) {
                    if (isexc || useCodeAsApplyValue) {
                        codes.push(selectlists[i].code);
                        items.push(selectlists[i]);
                    } else {
                        codes.push(selectlists[i].rowid);
                        let node = gridApi.getRowNode(selectlists[i].rowid);
                        items.push(node);
                    }
                }
            }
        } else {
            //double click
            if (isexc || useCodeAsApplyValue) {
                codes.push(selectnode.data.code);
            } else {
                codes.push(selectnode.data.rowid);
            }
            items.push(selectnode);
        }
        if (items.length === 0 && (isEmpty(datainfo) || !Array.isArray(datainfo.initialSelectedCodes))) {
            fnc.current.warnmsg("データを選択してください");
            return;
        } 
        if (cmdtype === 2 && mode === 1) {
            //Storage Delete
            if (dataid() === "p_storage") {
                if (storagename === codes[0]) {
                    fnc.current.warnmsg("表示中データの為削除できません");
                    return;
                }
                fnc.current.confmsg("選択した保存データを削除します。データの復帰はできませんがよろしいですか？", () => StorageDelete(codes));
            }
            if (dataid() === "sm_ptn") {
                if (shared && admin!=="1") {
                    fnc.current.warnmsg("権限がない為削除できません");
                    return;
                }
                else
                    fnc.current.confmsg("選択したパターンを削除します。データの復帰はできませんがよろしいですか？", () => PatternDelete(codes));
            }
            return;
        }

        if (props.inTag) {
            let data = { value: codes.join(' ')};
            doTagApply(data);
        } else {
            //検索ワード及びタグを保持（アカウント単位）
            if (!isEmpty(dataid())) {
                let data = { word: searchword, taglist: searchtaglist, shared: shared};
                Savestorage(corpkey, account, "SearchList_" + searchinfokey(), data);
            }

            let data = {
                key: datainfo.columnid,
                value: codes.join(' '),
                rowmode: rowmode,
                items: items,
                rowid: rowid,
                currowid: currowid,
                datainfo: datainfo,
                shared: shared
            };
            doApply(data, mode, mode===9)
        };
    }
    function applycolumn() {
        //列状態を更新 ToolPanel用
        var c = columns;
    //    setColumns(AGRef.current.GetApplyColumnDefs(columns));
    }

    function toolpanel() {
        if (!isexc) {
            settoolpanels([
                {
                    id: 'columns',
                    labelDefault: '',
                    labelKey: 'columns',
                    iconKey: 'columns',
                    toolPanel: 'agColumnsToolPanel',
                    toolPanelParams: {
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivots: true,
                        suppressPivotMode: true,
                        suppressColumnExpandAll: true,
                    },
                },
                {
                    id: 'customStats_search',
                    labelDefault: '',
                    labelKey: 'customStats',
                    iconKey: 'custom-tools',
                    toolPanel: CustomToolPanel,
                    toolPanelParams: {
                        fnc: fnc,
                        dataid: dataid(),
                        subkey: "",
                        type:"1000",
                        applycolumn: applycolumn,
                    },
                },
                {
                    id: 'customStats2_search',
                    labelDefault: '',
                    labelKey: 'customStats2',
                    iconKey: 'custom-tools2',
                    toolPanel: CustomToolorgPanel,
                    toolPanelParams: {
                        fnc: fnc,
                        dataid: props.controller,
                        subkey: props.subkey,
                        type: "1000",
                        savelayout: savelayout,
                        calllayout: calllayout
                   },
                },
            ]);
        } else {
            settoolpanels([
                {
                    id: 'columns',
                    labelDefault: '',
                    labelKey: 'columns',
                    iconKey: 'columns',
                    toolPanel: 'agColumnsToolPanel',
                    toolPanelParams: {
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivots: true,
                        suppressPivotMode: true,
                        suppressColumnExpandAll: true,
                    },
                }
            ]);
        }
    }
    //検索条件パネルを開く
    function OpenSearchpanel() {
    //    fnc.current.searchpanelopen({ items: searchitems, savekey: dataid(), doApply: searchexecute });
        setsearchpanelopen(true);
    }
    function searchexecute(itemdata, datainfo) {
        var id = dataid();
        if (!isEmpty(datainfo)) id = datainfo.dataid;
        //検索条件保存
        setglobaldata(id, itemdata);
        setsearchpanelopen(false);
        //fnc.current.searchpanelclose();
        GetMasterList(false, itemdata, undefined, id);
    }

    function onHandleClose() {
        if (props.inTag) {
            fnc.current.tagsearchclose();
        } else {
            if (props.SearchPanel) {
                //fnc.current.searchlistclose2();
                if (!isEmpty(props.doclose)) props.doclose();
            } else {
                fnc.current.searchlistclose();
            }
        }
    };

    //リスト内検索TAG選択リストOpen
    function SearchTag() {
        let data = {
            dataid: "m_tag_1:" + dataid(),
            datatype: CELLTYPE.TAG,
            columnid: "SearchTag",  //検索結果event識別子
        };
        dispatch(tagsearchopen({ data: data, doApply: SearchTagApply, zindex:zindex}));
    }
    //リスト内検索TAG決定
    function SearchTagApply(e) {
        let newtag = [];
        const tags = e.value.split(" ");
        for (let i = 0; i < tags.length; i++) {
            newtag.push(
                {
                    tag: tags[i],
                    mode: 0
                });
        }
        if (newtag.length !== 0) {
            //追加されたリスト内検索TAGを反映
            let newtags = [...newtag, ...searchtaglist];
            newtags = removeDuplicates(newtags);
            setsearchtaglist(newtags);
        }
        dispatch(tagsearchclose());
    }

    //再表示
    function Reload() {
        GetMasterList(false);
    }
    //クイックサーチ
    function FilterSearch(value) {
        setsearchword(value);
        gridApi.setGridOption('quickFilterText', value);
    }
    //検索タグ削除
    function removeSearchTag(deletetag) {
        const newtags = searchtaglist.filter(function (tag) {
            return tag !== deletetag;
        });
        setsearchtaglist(newtags);
    }
    //検索タグ除外設定変更
    function changeSearchTag(changetag) {
        var newtags = DeepCopy(searchtaglist);
        var tag = newtags.find(e => e.tag === changetag.tag);
        if (!isEmpty(tag))
            tag.mode = tag.mode === 0 ? 1 : 0;
        setsearchtaglist(newtags);
    }

    //マスタページURL
    //function JumpPageurl(key) {
    //    switch (dataid()) {
    //        case "m_brand":
    //            return "/Brand?key=" + key;
    //        case "m_splr":
    //            return "/Supplier?key=" + key;
    //        case "m_sect":
    //            return "/Section?key=" + key;
    //        case "m_matl":
    //            return "/Material?key=" + key;
    //        default:
    //            if (dataid().indexOf("m_code") !== -1) {
    //                return "/Code?type=" + dataid().split(':')[1] + "&key=" + key;
    //            }
    //    }
    //    return "";
    //}
    //function ActionLink() {
    //    let key = continueSession(user, menu);
    //    let url = JumpPageurl(key);
    //    if (url !== "") {
    //        window.open(url);
    //        //history.push(url);
    //    }
    //}
    //AG-grid event
    function onGridReady(params) {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    }
    function onRowDataUpdated(params) {
        applyInitialSelection(params.api);
    }
    function onCellDoubleClicked(params) {
        //if (params.column.colId !== 'code' && rowSelection !== 'single')
        //    return;
        gridApi.deselectAll();
        Execute(2, params.node);
    }
    function onSelectionChanged(param) {
        if (rowSelection === 'single') return;
        var nodes = param.api.getSelectedNodes();
        if (nodes.length === 0) {
            setshowselect(false);
            setselectlists([]);
            return;
        }
        let list = DeepCopy(selectlists);
        let newlist = [];
        for (let i = 0; i < nodes.length; i++) {
            newlist.push(nodes[i].data);
        };
        let del = arrayDiff(list, newlist);     //旧リストと新リストの差（削除分）
        list = arrayDiff(list, del);            //旧リストと削除分の差
        let add = arrayDiff(newlist, list);     //新リストと旧リストの差（追加分）
        list = list.concat(add);
        setshowselect(true);
        setselectlists(list);
    }
    //function arrayDiff(arr1, arr2) {
    //    var str_arr2 = JSON.stringify(arr2); //配列arr2の文字列表現
    //    return arr1.filter(item => str_arr2.indexOf(JSON.stringify(item)) < 0); //itemの文字列表現を検索。
    //}
    //選択リスト削除
    function deSelect(code) {
        let list = DeepCopy(selectlists);
        let target = list.filter(e => e.code === code);
        if (target.length !== 0) {
            let node = gridApi.getRowNode(isexc ? target[0].code:target[0].rowid);
            if (node !== null) node.setSelected( false);
        }
        list = list.filter(e => e.code !== code);
        setselectlists(list);
        setshowselect(list.length !== 0);
    }

    //TAG検索
    function isExternalFilterPresent() {
        try {
            let data = getglobaldata(tagkey);
            if (isEmpty(data)) return false;
            return data.length !== 0;
        } catch (error) {
            return false;
        }
    };
    function doesExternalFilterPass(node) {
        let taglist = getglobaldata(tagkey);
        if (taglist.length === 0) return true;
        //検索TAGによるFilter
        let rowtag = "";
        for (let i = 0; i < taginfo.length; i++) {
            if (isEmpty(node.data[taginfo[i].columnid])) continue;
            rowtag += (i === 0 ? '' : ' ') + node.data[taginfo[i].columnid];
        }
        let tags = rowtag.split(' ');
        //除外Tag
        let exclude = taglist.filter(function (taglist) {
            return taglist.mode === 1;
        });
        for (let i = 0; i < exclude.length; i++) {
            if (tags.indexOf(exclude[i].tag) !== -1) //除外TAG有り
                return false;
        }
        //抽出Tag
        let include = taglist.filter(function (taglist) {
            return taglist.mode === 0;
        });
        if (include.length === 0) return true;
        for (let i = 0; i < include.length; i++) {
            if (tags.indexOf(include[i].tag) !== -1) //検索TAG有り
                return true;
        }
        return false;
    };

    function storagekey() {
        return props.inTag ? tagdatainfo.dataid : dataid() + "_select";
    }
    const onFirstDataRendered = useCallback((params, datainfo, rowdata) => {
        if (isEmpty(datainfo)) return;
        if (datainfo.dataid === "d_porder_row") {   //加工発注№
            if (!isEmpty(DicVal(rowdata, "d_sale_r_row_code"))) { //原材料コードが決定済の場合
                var hardcodedFilter = {
                    d_porder_r_row_code: {
                        type: 'set',
                        values: [rowdata["d_sale_r_row_code"]],
                    },
                };
                params.api.setFilterModel(hardcodedFilter); //フィルタ
            }
        }
        if (getglobaldata(colfixkey)) {
            AGRef.current.AutoSizeColumns(false);
        }
    }, []);
    //列幅変更
    function ColumnResized(param) {
        if (param.finished) {
            ColumninfoAppy();
        }
    }
    //列情報保存
    function ColumninfoAppy() {
        if (dataid() === "history" || dataid() === "sm_ptn") return;
        AGRef.current.SaveColState(storagekey());
        // 旧バージョンでは状態はDefsの更新が必要だったが、Stateになったため不要
        // setColumns(AGRef.current.GetApplyColumnDefs(columns));
    }
    function getContextMenuItems(params) {
        var result = [];
        if (rowSelection !== "single") {
            result.push(
                {
                    name: '全選択',
                    action: function () {
                        params.api.selectAllFiltered();
                   },
                });
            result.push(
                {
                    name: '選択解除',
                    action: function () {
                        params.api.deselectAll();
                    },
                });
            result.push(
                {
                    name: '選択行反転',
                    action: function () {
                        params.api.forEachNodeAfterFilter(node => node.isSelected() ? node.setSelected(false) : node.setSelected(true));
                   },
                });
            result.push('separator');
        }
        result.push(
            {
                name: '行の高さ',
                subMenu: [
                    {
                        name: '通常',
                        action: function () {
                            params.api.forEachNode(function (rowNode) {
                                rowNode.setRowHeight(28);
                            });
                            params.api.onRowHeightChanged();
                            AGRef.current.SaveRowHeight(storagekey(), null);
                        },
                    },
                    {
                        name: '中',
                        action: function () {
                            params.api.forEachNode(function (rowNode) {
                                rowNode.setRowHeight(80);
                            });
                            params.api.onRowHeightChanged();
                            AGRef.current.SaveRowHeight(storagekey(), 80);
                        },
                    },
                    {
                        name: '高',
                        action: function () {
                            params.api.forEachNode(function (rowNode) {
                                rowNode.setRowHeight(120);
                            });
                            params.api.onRowHeightChanged();
                            AGRef.current.SaveRowHeight(storagekey(), 120);
                         },
                    },
                ]
            }
        );
        result.push('separator');
        if (dataid() === "history") {
        }else if(dataid() === "sm_ptn" || dataid() === "p_storage") {
            result.push(
                {
                    name: '名前の変更',
                    action: function () {
                        if (shared && admin !== "1" && dataid() === "sm_ptn") {
                            fnc.current.warnmsg("権限がない為変更できません");
                            return;
                        }
                        fnc.current.clearconvdescription();
                        var lst = gridApi.getSelectedNodes();
                        if (lst.length === 0) {
                            fnc.current.warnmsg("データを選択してください");
                            return;
                        }
                        if (storagename === lst[0].data.code && dataid() === "p_storage") {
                            fnc.current.warnmsg("表示中データの為変更できません");
                            return;
                        }
                        fnc.current.formdialogopen(
                            {
                                title: "名前の変更", inputname: "新しい名前",
                                contents: "新しい名前を入力してください",
                                placeholder: lst[0].data.code,
                                cmdlabel: "登録",
                                onApply: (param) => ReName(param, lst[0])
                            });
                    },
                });
        } else {
            result.push(
                {
                    name: 'TAG追加',
                    tooltip: '選択行データにMyTAGの追加を行います',
                    action: function () {
                        fnc.current.clearconvdescription();
                        const ranges = params.api.getCellRanges();
                        if (ranges.length === 0) {
                            fnc.current.warnmsg("MyTAGセルを選択してください");
                            return;
                        }
                        let tagcol = "";
                        let columns = [];
                        for (let idx = 0; idx < ranges.length; idx++) {
                            for (let i = 0; i < ranges[idx].columns.length; i++) {
                                let column = ranges[idx].columns[i].colDef.colinfo;
                                if (isEmpty(column)) continue;
                                if (column.datatype === CELLTYPE.TAG && column.columnid.indexOf('mytags') !== -1) {
                                    columns.push(ranges[idx]);
                                    tagcol = column.columnid;
                                }
                            }
                        }
                        if (columns.length === 0) {
                            fnc.current.warnmsg("MyTAGセルを選択してください");
                            return;
                        }
                        fnc.current.formdialogopen(
                            {
                                title: "MyTAG追加", inputname: "TAG",
                                contents: "選択されているMyTAGセルにTAGを追加登録します",
                                placeholder: "スペース区切りで複数TAG入力できます",
                                cmdlabel: "登録",
                                onApply: (param) => AddTagsCell(param, columns, tagcol)
                            });
                    },
                });
            result.push(
                {
                    name: 'TAG編集',
                    tooltip: 'TAG削除を有効にするかを設定します',
                    checked: tagdel,
                    action: function () {
                        settagdel(!tagdel);
                    },
                });
        }
        return result;
    };
    //名前の変更
    function ReName(newname, node) {
        let oldname = node.data.code;
        if (newname === oldname) {
            fnc.current.warnmsg("元の名前と同じです");
            return;
        }
        try {
            let url = 'common/PatternRename';
            if (dataid() === "p_storage") {
                url = location.pathname.replace('/', '') + "/StorageRename";
            }
            fnc.current.postaxios(url,
                {
                    "dataid": dataid(),
                    "name": newname,
                    "abbr": shared?"1":"",
                    "keyinfo": oldname,
                    "datainfo": datainfo
                },
                {
                    onSuccess: function (data) {
                        fnc.current.formdialogclose();
                        node.setDataValue("code", newname);
                        fnc.current.success();
                        fnc.current.wait(false);
                    }
                })
        } catch (error) {
            console.log(error);
        }
    }
    //ToolTAGよりTAG追加
    function AddTagsCell(tags, ranges,tagcol) {
        var rowdata = [];
        for (let i = 0; i < ranges.length; i++) {
            let min = ranges[i].startRow.rowIndex > ranges[i].endRow.rowIndex ? ranges[i].endRow.rowIndex : ranges[i].startRow.rowIndex;
            let max = ranges[i].startRow.rowIndex < ranges[i].endRow.rowIndex ? ranges[i].endRow.rowIndex : ranges[i].startRow.rowIndex;
            gridApi.forEachNodeAfterFilter(function (node) {
                if (node.rowIndex >= min && node.rowIndex <= max) {
                    rowdata.push(node.data);
                }
            });
        }
        try {
            fnc.current.postaxios('common/AddMyTag',
                {
                    "tabletype": dataid(),
                    "code": tags,
                    "rowdata": rowdata,
                },
                {
                    onSuccess: function (data) {
                        fnc.current.formdialogclose();
                        for (let i = 0; i < rowdata.length; i++) {
                            let rowid = rowdata[i].rowid;
                            let node = gridApi.getRowNode(rowid);
                            var tagcellvalue = node.data[tagcol];
                            var newtag = tagformat(tags + " " + tagcellvalue);
                            node.setDataValue(tagcol, newtag);
                        }
                        fnc.current.wait(false);
                    }
                })
        } catch (error) {
            console.log(error);
        }
    }

    const cellRendererParams = {
        edittag: function (colid) {
            if (!tagdel) return false;
            return colid.indexOf("my") !== -1
        },
        deletetag: function (e, newtag, targettag) {
            try {
                let rowNode = gridApi.getRowNode(e.data.rowid);
                fnc.current.postaxios('common/DeleteMyTag',
                    {
                        "tabletype": dataid(),
                        "code": targettag,
                        "rowdata": [rowNode.data],
                    },
                    {
                        onSuccess: function (data) {
                            let rowNode = gridApi.getRowNode(e.data.rowid);
                            rowNode.setDataValue(e.colDef.colId, newtag);
                            fnc.current.wait(false);
                        }
                    })
            } catch (error) {
                console.log(error);
            }

        }
    };

    function getMainMenuItems(params) {
        const athleteMenuItems = params.defaultItems.slice(0);
        athleteMenuItems.pop(); //Reset column削除
        athleteMenuItems.pop();
        return athleteMenuItems;
    };
    function getRowHeight(params) {
        return isEmpty(rowHeight)?undefined: rowHeight;
    };
    function valueFormatter(params) {
        if (params.value === '') return params.value;
        let colinfo = params.colDef.colinfo;
        if (colinfo === null) return params.value;
        try {
            if (colinfo.datatype === CELLTYPE.NUM) {
                var number = Number(params.value);
                if (number === 0 && colinfo.format.indexOf('showzero') === -1) {
                    return "-";
                }
                if (colinfo.format.indexOf('unuseGrouping') !== -1) return number.toString(); //カンマ区切りなし
                if (colinfo.decimalplace === 0) {
                    return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
                } else {
                    return number.toLocaleString(undefined, {
                        minimumFractionDigits: colinfo.decimalplace,
                        maximumFractionDigits: colinfo.decimalplace
                    });
                }
            }
            if (colinfo.datatype === CELLTYPE.MASTER) {
                if (!isEmpty(colinfo.dbcolumn)) {
                    return params.value + ":" + params.data[params.colDef.colId + "_nm"];
                }
                return params.value;
            }
            if (colinfo.datatype === CELLTYPE.SELECT) {
                let result = colinfo.options.find(e => e.code === params.value.toString());
                if (!isEmpty(result))
                    return params.value + ":" + result.name;
                return params.value;
            }
        } catch {
            return params.value;
        }
        return params.value;
    }

    function isSearchTag() {
        if (datainfo === null) return false;
        if (datainfo.datatype !== CELLTYPE.SELECT && !isEmpty(datainfo.keyinfo)) return true; //d_prod_color etc..
        return datainfo.columnid === "SearchTag";
    }
    function isAllSKU() {
        if (dataid() === "d_prod" || dataid() === "d_inst" || dataid() === "m_matl" || dataid() === "m_smatl") {
            if (datainfo === null) return true;
            var params = DicVal(datainfo, "searchparam");
            if (isEmpty(params)) return true;
            let ret = DicVal(params, "allsku");
            if (isEmpty(ret)) return true;
            return !(ret.toLowerCase() === "false");
        } else {
            return false;
        }
    }
    function ToolCommand() {
        if (isexc) {
            if (cmdtype === 2) {    //Storage
                return <React.Fragment>
                    <Button variant="outlined" size="small" onClick={() => Execute(0)}>開く</Button>
                    <Button variant="outlined" size="small" onClick={() => Execute(1)} title="選択データを削除します">削除</Button>
                </React.Fragment>
            }
            if (cmdtype === 0 || isSearchTag)
                return <Button variant="outlined" size="small" onClick={() => Execute(0)}>適用</Button>
            if (cmdtype === 1) {    //TAG
                return <React.Fragment>
                    <Button variant="outlined" size="small" onClick={() => Execute(0)}>追加</Button>
                    <Button variant="outlined" size="small" onClick={() => Execute(1)} title="選択TAGをセルから除外します">削除</Button>
                </React.Fragment>
            }
        } else {
            if (props.inTag || rowSelection === 'single' || rowmode === false) {
                return <Button variant="outlined" size="small" onClick={() => Execute(0)}>適用</Button>
            } else {
                if (isAllSKU()) {
                    return <React.Fragment>
                        <Button variant="outlined" size="small" onClick={() => Execute(9)}>全SKU</Button>
                        <Button variant="outlined" size="small" onClick={() => Execute(0)}>挿入</Button>
                        <Button variant="outlined" size="small" onClick={() => Execute(1)}>上書</Button>
                    </React.Fragment>
                } else {
                    return <React.Fragment>
                        <Button variant="outlined" size="small" onClick={() => Execute(0)}>挿入</Button>
                        <Button variant="outlined" size="small" onClick={() => Execute(1)}>上書</Button>
                    </React.Fragment>
                }
            }
        }
    }

    const columnDefs = useMemo(
        () =>
            columns.map((column) => ({
                ...column,
                cellRenderer:
                    column.datatype === CELLTYPE.TAG ||
                        column.datatype === CELLTYPE.COLOR
                        ? TagRenderer
                        : undefined,
                cellRendererParams: cellRendererParams,
                valueFormatter: valueFormatter,
            })),
        [columns, cellRendererParams, valueFormatter]
    );

    return (
        <div>
            <Drawer
                anchor={"right"} open={show} onClose={onHandleClose} BackdropProps={{ invisible: true }}
                style={{ zIndex: zindex}}
                PaperProps={{ style: { width: drawerWidth } }}
            >
                <div
                    onMouseDown={handleResizeMouseDown}
                    style={{ position: 'absolute', top: 0, left: 0, width: 8, height: '100%', cursor: 'ew-resize', zIndex: 1 }}
                />
                <div style={{ marginRight: 10 }}>
                    <div style={{ textAlign: 'left', float: 'left', marginTop: 10, marginLeft: 20}}>
                        <span >{props.inTag?'TAG':label}</span>
                    </div>
                    <div style={{ textAlign: 'right', marginTop: 10 }} >
                        <ToolCommand />
                        <Button variant="outlined" size="small" onClick={onHandleClose}>中止</Button>
                    </div>
                    {dataid()==="sm_ptn"?
                        <div style={{position:'absolute', left:200, top:8}}>
                            <FormControlLabel
                                control={<Switch checked={shared} onChange={sharedChange} color="default" size="small" />}
                                label={
                                    <Box component="div" fontSize={12}>
                                        共有
                                    </Box>
                                }
                        />
                        </div>
                    :null}
                </div>
                <div style={{ padding: '0 10px', width: '100%', marginBottom:5 }}>
                    <Paper component="div" className={classes.root} style={{ width: '100%' }}>
                        <span style={{ maxwidth: '70%' }}>
                            {searchtaglist.map(tag => (
                                <Chip
                                    size="small"
                                    label={tag.tag}
                                    onDelete={() => removeSearchTag(tag)}
                                    onClick={() => changeSearchTag(tag)}
                                    style={{ backgroundColor: tag.mode === 1 ? 'firebrick' : 'aquamarine', color: "white" }}
                                    className={classes.chip}
                                />
                            ))}
                        </span>
                        <InputBase
                            className={classes.input}
                            value={searchword}
                            placeholder="検索ワード"
                            onChange={(e) => FilterSearch(e.target.value)}
                        />
                        <span style={{ cursor: 'pointer', marginRight: 20, paddingTop: 10 }} onClick={() => FilterSearch("")}>
                            <i class="material-icons delete">close</i>
                        </span>
                        {isexc ?
                            null :
                            <IconButton size="small" onClick={SearchTag} title={"検索タグ"} >
                                <Icon>sell</Icon>
                            </IconButton>
                        }
                        <Divider className={classes.divider} orientation="vertical" />
                       <IconButton size="small" onClick={Reload} title={"再表示"} >
                            <Icon>refresh</Icon>
                        </IconButton>
                        {useSearchPanel ?
                            <React.Fragment>
                                <Divider className={classes.divider} orientation="vertical" />
                                <IconButton size="small" onClick={OpenSearchpanel} title={"検索条件"} >
                                <Icon>search</Icon>
                                </IconButton>
                            </React.Fragment>
                            :null
                        }
                    </Paper>
                </div>
               <div className="ag-theme-balham" style={{ height: '100%', width: '100%' }}>
                    <AgGridReact
                        theme={themeBalham}
                        columnMenu="legacy"
                        icons={icons}
                        getRowId={params => RowNodeId(params.data)}
                        sideBar={{
                            toolPanels: toolpanels
                        }}
                        onGridReady={onGridReady}
                        onRowDataUpdated={onRowDataUpdated}
                        onFirstDataRendered={(e) => onFirstDataRendered(e,datainfo,rowdata)}
                        headerHeight={30}
                        modules={[AllCommunityModule, AllEnterpriseModule]}
                        getRowHeight={getRowHeight}
                        multiSortKey={'ctrl'}
                        defaultColDef={defaultColDef}
                        getMainMenuItems={getMainMenuItems}
                        getContextMenuItems={getContextMenuItems}
                        rowSelection={rowSelection}
                        rowMultiSelectWithClick={true}
                        enableRangeSelection={true}
                        isExternalFilterPresent={isExternalFilterPresent}
                        doesExternalFilterPass={doesExternalFilterPass}
                        onCellDoubleClicked={onCellDoubleClicked}
                        onColumnResized={ColumnResized}
                        onColumnVisible={ColumninfoAppy}
                        onColumnPinned={ColumninfoAppy}
                        onColumnMoved={ColumninfoAppy}
                        onSelectionChanged={onSelectionChanged}
                        rowData={rowData}
                        columnDefs={columnDefs}>
                    </AgGridReact>
                </div>
                <Snackbar
                    anchorOrigin={{ vertical, horizontal }}
                    open={showselect}
                    ContentProps={{
                        classes: {
                            root: classes.snackbar
                        }
                    }}
                    message={
                        <React.Fragment>
                            <div style={{ maxHeight: 100, overflow: 'auto', marginTop: 5, width:250 }}>
                                {selectlists.map(item => (
                                    <div>
                                        <IconButton
                                            color="inherit"
                                            sx={{ mr: 10 }}
                                            size="small"
                                            onClick={()=>deSelect(item.code)}
                                        >
                                            <span class="material-icons editlink">close</span>
                                        </IconButton>
                                        <span>{item.code}</span>
                                    </div>
                                ))}
                            </div>
                        </React.Fragment>
                    }
                />
            </Drawer>
            <ComFunc ref={fnc} />
            <AGFunc
                ref={AGRef}
                gridApi={gridApi}
                gridColumnApi={gridColumnApi}
            />
            <SearchPanel
                open={searchpanelopen}
                onClose={() => setsearchpanelopen(false)}
                controller={dataid()}
                subkey={'inner'}
                fnc={fnc.current}
                items={searchitems}
                savekey={dataid()}
                doApply={searchexecute}
            />
        </div>
    );
};
